import { useEffect, useState } from 'react'
import type { Disposables } from '../utilities/createDisposables'
import createDisposables from '../utilities/createDisposables'

export function useDisposables(): Disposables {
  const [d] = useState(createDisposables)

  useEffect(() => () => d.dispose(), [d])

  return d
}
